import { executeRequest, Request } from '@jfs/network'
import { RootStore } from '../../data/store'
import { getNetworkResponseError, isStatusSuccess } from '../../util/utill'
import { APIEndPoints } from '../APIEndPoints'
import { sitConfig } from '../config'
import { sendEventApi } from '../sendEvent'

const responseParser = ({ data }: any) => {
  if (isStatusSuccess(data) || data?.error?.code === CUSTOMER_VALIDATION_CODES?.DOES_NOT_EXIST) {
    return data?.data || data?.error
  } else {
    throw getNetworkResponseError(data)
  }
}

const customHeader = (tokens: any) => {
  const sitToken = sitConfig(tokens)
  return sitToken
}

export const checkWhetherTheCustomerExistsApi = (tokens: any, mobile: string) => {
  const config = customHeader(tokens)
  config.headers['x-user-access-token'] = RootStore?.bcAppInfo?.userAccessToken
  config.headers['x-userid-token'] = RootStore?.bcAppInfo?.userIdentifier

  const request: Request<{}> = {
    apiPath: `${APIEndPoints.checkCustomerExist}/${mobile}`,
    method: 'GET',
    config,
  }
  sendEventApi(tokens, request, {
    status: 'INITIATED',
  })
  return executeRequest(request)
    .then((data) => {
      return responseParser(data)
    })
    .then((response) => {
      sendEventApi(tokens, request, {
        status: 'SUCCESS',
      })
      return response
    })
    .catch((err) => {
      sendEventApi(tokens, request, {
        status: 'FAILED',
        errorDescription: err,
      })
      throw err
    })
}

export const CUSTOMER_VALIDATION_CODES = {
  DOES_NOT_EXIST: '30013',
}
